export default {
  name: 'mapconfigv2header',
  components: {},
  meta: {
    title: ''
  },
  data() {
    return {
      title: '珠海地图'
    };
  },
  mounted() {},
  watch: {},
  methods: {}
};